/**
 * Klientens indgangspunkt.
 *
 * Service worker'en registreres kun, når browseren understøtter den.
 * Den bruges udelukkende til pushnotifikationer og til at cache app-skallen
 * — ALDRIG til at cache private API-svar (§11).
 */

import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

const container = document.getElementById('root');
if (!container) throw new Error('Elementet #root mangler i index.html.');

createRoot(container).render(<App />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // En manglende service worker må ikke forhindre appen i at køre.
    });
  });
}
